import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { AccessControl } from "./sidebar/types";

export const useAccessControls = (userType: "admin" | "owner") => {
  const { data: accessControls, refetch } = useQuery({
    queryKey: ["accessControls", userType],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) throw new Error("User not authenticated");

      const { data, error } = await supabase
        .from("access_controls")
        .select("*")
        .eq("owner_id", user.id);

      if (error) throw error;
      return data as AccessControl[];
    },
  });

  return { accessControls, refetch };
};